<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option mgb_5">
				<em class="lt_text">Sales Date</em>
				<span class="mgr_15"> <CustomDatePicker v-model="date_from"/> ~ <CustomDatePicker v-model="date_to"/></span>

				<em class="lt_text">Item {{ headers.class }}</em>
				<span class="int_type_no_border mgr_5">
					<ItemClassSelectMulti v-model.trim="item_classes_string" :selectOnClick="false" :width="300" @keydown="search" />
				</span>

				<em class="lt_text">Item Color</em>
				<span class="int_type mgr_15">
					<input type="text" v-model.trim="colors_string" placeholder="ex) 1, 2, 1B" autocomplete="off" @keyup.enter="search()" @focus="$event.target.select()" />
				</span>

				<span class="int_type_no_border mgr_15">
					<ItemSelectMulti v-model.trim="selected_items_str" :active_only="false" :separator="separator" :resultsDisplay="obj => obj.item_code + ' | ' + obj.name" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 95%">
				<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
					<colgroup>
						<col style="width: 5%;" />
						<col style="width: 10%;" />
						<col style="width: 10%;" />
						<col style="width: 5%;" />
						<col />
						<col style="width: 10%;" />
						<col style="width: 10%;" />
						<col style="width: 8%;" />
					</colgroup>
					<thead>
						<tr>
							<th>#</th>
							<th>Item Code</th>
							<th>{{ headers.class }}</th>
							<th>Color</th>
							<th>Item Name</th>
							<th>Total Qty</th>
							<th>Total Amount</th>
							<th>Invoice Count</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, idx) in items" :key="idx">
							<td class="al_center">{{ idx + 1 }}</td>
							<td class="al_left">{{ item.item_code }}</td>
							<td class="al_left truncate" :title="item.class_name">{{ item.class_code }}</td>
							<td class="al_center">{{ item.color_code }}</td>
							<td class="al_left truncate" :title="item.item_name">{{ item.item_name }}</td>
							<td class="al_right">{{ item.total_quantity | commaSeparated }}</td>
							<td class="al_right">{{ item.total_amount | toCurrency }}</td>
							<td class="al_right">{{ item.invoice_count | commaSeparated }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div style="text-align:right;padding-right:10px;">Items: {{ sum.item_count | commaSeparated }}, Total Qty: {{ sum.total_quantity | commaSeparated }}, Total Amount: {{ sum.total_amount | toCurrency }}</div>

		<div class="view_bottom_bt">
			<a href="javascript:void(0);" type="button" class="search_bt" @click="exportExcel">Excel</a>
		</div>
	</div>
</template>

<script>
import { apiHistoricalSalesByItem } from '@/api/report/report.js';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import ItemSelectMulti from '@/components/common/ItemSelectMulti';
import { exportExcel } from '@/api/util';

export default {
	data: () => ({
		date_from: '',
		date_to: '',
		item_classes_string: '',
		colors_string: '',
		selected_items_str: '',
		separator: ',',
		items: [],
		sum: {},
	}),
	components: {
		CustomDatePicker,
		ItemClassSelectMulti,
		ItemSelectMulti,
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
		headers() {
			return this.$store.state.headers || { class: 'Class' };
		},
	},
	methods: {
		async search() {
			const item_classes = this.item_classes_string
				? this.item_classes_string
						.split(',')
						.map(s => s.trim())
						.filter(s => s)
				: null;
			const color_codes = this.colors_string
				? this.colors_string
						.split(',')
						.map(s => s.trim())
						.filter(s => s)
				: null;
			const item_codes = this.selected_items_str
				? this.selected_items_str
						.split(this.separator)
						.map(s => s.trim())
						.filter(s => s)
				: null;

			const param = {
				date_from: this.date_from,
				date_to: this.date_to,
				item_classes,
				color_codes,
				item_codes,
			};

			const { data } = await apiHistoricalSalesByItem(param);
			this.items = data.list || [];
			this.sum = data.sum || {};
		},
		reset() {
			this.date_from = '';
			this.date_to = '';
			this.item_classes_string = '';
			this.colors_string = '';
			this.selected_items_str = '';
			this.items = [];
			this.sum = {};
		},
		exportExcel() {
			exportExcel('excelTable', 'HistoricalSalesByItem');
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_historical_sales_by_item');
		this.$store.commit('setSubTitle', 'Report -> Historical Sales by Item');

		const today = this.$moment(new Date());
		this.date_from = today
			.clone()
			.subtract(1, 'year')
			.format('MM-DD-YYYY');
		this.date_to = today.format('MM-DD-YYYY');
	},
};
</script>

<style></style>
